import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { LOAD_SUBMISSION_HISTORY } from "../../../../store/lender-submit-actions";
import SubmissionStatusBadge from "../lender-response/submission-status-badge.vue";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { capitalize, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SubmissionHistoryTable",
  components: {
    SubmissionStatusBadge,
    NotificationPopover
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tableColumns: ["date", "type", "lender", "status", "insurance", "mortgage", "loanAmount", "actions"]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", ["getSubmissionHistory"])), {}, {
    submissions() {
      var _context;
      const submissionHistory = this.getSubmissionHistory;
      if (isEmpty(submissionHistory.byId)) return [];
      return _mapInstanceProperty(_context = submissionHistory.allIds).call(_context, submissionId => submissionHistory.byId[submissionId]);
    },
    isEmptyData() {
      return isEmpty(this.submissions);
    },
    submissionColumns() {
      return [this.$t("global.words.date"), capitalize(this.$tc("global.words.type", 1)), this.$t("global.doorr.lender"), this.$t("global.words.status"), this.$t("global.words.progress"), this.$t("global.words.insurance"), this.$t("global.doorr.mortgage"), this.$t("direct-to-lender.lenderSubmit.loanAmount"), ""];
    },
    options() {
      return {
        sortable: [],
        filterable: false,
        showChildRowToggler: false,
        perPage: 999999,
        orderBy: {
          ascending: false,
          column: "date"
        },
        customSorting: {
          date(ascending) {
            return (a, b) => {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              if (ascending) return dateA >= dateB ? 1 : -1;
              return dateA <= dateB ? 1 : -1;
            };
          }
        },
        headings: {
          date: this.$t("global.words.date"),
          type: capitalize(this.$tc("global.words.type", 1)),
          lender: this.$t("global.doorr.lender"),
          status: this.$t("global.words.status"),
          insurance: this.$t("global.words.insurance"),
          mortgage: this.$t("global.doorr.mortgage"),
          loanAmount: this.$t("direct-to-lender.lenderSubmit.loanAmount"),
          actions: this.$t("global.words.actions")
        },
        columnsClasses: {
          actions: "hidden-heading"
        },
        texts: {
          count: ""
        },
        tabbable: false,
        skin: "table table-hover"
      };
    }
  }),
  mounted() {
    this.reloadSubmissionHistory();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_SUBMISSION_HISTORY])), {}, {
    reloadSubmissionHistory() {
      const {
        clientUsername,
        applicationId
      } = this;
      this.LOAD_SUBMISSION_HISTORY({
        clientUsername,
        applicationId
      });
    },
    applicationPdf(row) {
      this.$emit("application-pdf", row);
    },
    lenderNote(row) {
      this.$emit("lender-note", row);
    },
    parseErrors(submission) {
      var _context2;
      if (isEmpty(submission.errorForUser)) return [];
      const {
        businessErrors,
        xmlSchemaError,
        internalError
      } = submission.errorForUser;
      const errors = _reduceInstanceProperty(_context2 = [...((businessErrors == null ? void 0 : businessErrors.businessErrors) || []), xmlSchemaError]).call(_context2, (acc, current) => {
        if (current != null && current.errorText) {
          acc.push(`${current.errorText} ${!current.softStop ? "(mandatory)" : ""}`);
        } else if (current) acc.push(current);
        return acc;
      }, []);
      if (internalError) errors.push(this.$t("direct-to-lender.lenderSubmit.connectionIssue"));
      return errors;
    },
    shouldShowProcessingTooltip(row) {
      return row.status === "processing" && row.submissionMethod === "electronic";
    }
  })
});